import Controller from "./godsViewMap.controller";
import template from "./godsViewMap.html";

const godsViewMap = {
  template,
  controller: Controller,
};

export default godsViewMap;



// WEBPACK FOOTER //
// ./src/components/godsViewMap/godsViewMap.component.js